import React, { memo } from 'react';
import { View, StyleSheet, TouchableOpacity } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { Text } from '@redlink/components/atoms';
import { isMobile } from 'react-device-detect';

export const PinButton = memo(
  ({ icon, title, activeOpacity, style, ...rest }) => {
    const { styles } = useStyle();
    return (
      <TouchableOpacity
        activeOpacity={0.9}
        style={[
          styles.container,
          style,
          styles.fixContainer,
          !isMobile && styles.fixContainerLandscape,
        ]}
        {...rest}
      >
        {icon}
        <View style={styles.textContainer}>
          <Text style={styles.text}>{title}</Text>
        </View>
      </TouchableOpacity>
    );
  }
);

const useStyle = createUseStyle(({ colors, size, shadow }) => ({
  fixContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: colors.green1,
  },
  fixContainerLandscape: {
    borderRadius: 10,
    marginBottom: 25,
    marginHorizontal: 24,
  },
  container: {
    paddingVertical: 15,
    paddingHorizontal: 20,
    height: 56,
  },
  textContainer: {
    ...StyleSheet.absoluteFillObject,
    justifyContent: 'center',
  },
  text: {
    textAlign: 'center',
    fontSize: 14,
    color: colors.white,
  },
}));
